{
    "home": "Bienvenue"
}